import { render, staticRenderFns } from "./UpdateCompanyInfo.vue?vue&type=template&id=2fc2ae8d&scoped=true&"
import script from "./UpdateCompanyInfo.vue?vue&type=script&lang=js&"
export * from "./UpdateCompanyInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fc2ae8d",
  null
  
)

export default component.exports